export default "__VITE_ASSET__CunID52k__"